export default {
  countryInfo: require('./country-info.json')
}
